import { useEffect } from 'react'

/**
 * Horizontal trackpad / Magic Mouse wheel swipes switch tabs (same idea as browser history,
 * but bound to tab strip instead of back/forward).
 */
export function useHorizontalWheelTabNavigation(
  switchToNextTab: () => void,
  switchToPreviousTab: () => void
) {
  useEffect(() => {
    const SWIPE_THRESHOLD = 80
    const MIN_HORIZONTAL_DELTA = 25
    const MIN_VELOCITY = 0.5

    let swipeStartX = 0
    let swipeDetected = false
    let eventCount = 0
    let lastEventTime = 0

    const handleWheel = (event: WheelEvent) => {
      const horizontalDelta = Math.abs(event.deltaX)
      const verticalDelta = Math.abs(event.deltaY)

      const currentTime = Date.now()
      const timeDelta = currentTime - lastEventTime || 1
      const velocity = horizontalDelta / timeDelta
      lastEventTime = currentTime

      if (
        horizontalDelta > verticalDelta &&
        horizontalDelta > MIN_HORIZONTAL_DELTA &&
        (velocity > MIN_VELOCITY || eventCount > 0)
      ) {
        event.preventDefault()

        swipeStartX += event.deltaX
        eventCount++

        if (Math.abs(swipeStartX) > SWIPE_THRESHOLD && !swipeDetected) {
          swipeDetected = true

          if (swipeStartX > 0) {
            switchToPreviousTab()
          } else {
            switchToNextTab()
          }

          setTimeout(() => {
            swipeStartX = 0
            swipeDetected = false
            eventCount = 0
            lastEventTime = 0
          }, 300)
        }
      } else {
        swipeStartX = 0
        swipeDetected = false
        eventCount = 0
        lastEventTime = 0
      }
    }

    window.addEventListener('wheel', handleWheel, { passive: false })

    return () => {
      window.removeEventListener('wheel', handleWheel)
    }
  }, [switchToNextTab, switchToPreviousTab])
}
